import { styled, Typography, useTheme } from "@mui/material";
import { Row } from "v2/components/base/Flex/ui";

const TransparentInput = styled("input")(({ theme }) => ({
  all: "unset",
  backgroundColor: "transparent",
  border: `1px solid ${theme.palette.border.light}`,
  borderRadius: "16px",
  outline: "none",
  paddingY: "12px",
  width: "100%",
  height: "45px",
  textAlign: "center",
  ...theme.typography["mobile-body-s"],
  "&:focus, &:not(:placeholder-shown)": {
    opacity: "1",
    outline: "none",
  },
  "&::placeholder": {
    color: theme.palette.text.secondary,
    ...theme.typography["mobile-body-s"],
  },
  color: theme.palette.text.primary,
}));

const TransparentInputWithUnit = ({
  type,
  unit,
  amountRef,
  measureRef,
  placeholder,
  onInputChange,
  defaultValue,
}: {
  unit: string;
  type: string;
  amountRef: React.RefObject<HTMLInputElement>;
  placeholder: string;
  measureRef: React.RefObject<HTMLSpanElement>;
  onInputChange: () => void;
  defaultValue: any;
}) => {
  const theme = useTheme();
  return (
    <Row
      type="cc"
      onClick={() => {
        amountRef.current?.focus();
      }}
      sx={{
        border: `1px solid ${theme.palette.border.light}`,
        height: "45px",
        paddingY: "12px",
        borderRadius: "16px",
      }}
      fullWidth>
      <TransparentInput
        type={type}
        ref={amountRef}
        sx={{
          width: "fit-content",
          display: "inline-block",
          padding: "4px",
          minWidth: "0",
          boxSizing: "border-box",
          border: "none",
        }}
        placeholder={placeholder}
        onChange={() => {
          onInputChange();
        }}
        defaultValue={defaultValue}
      />
      <span
        ref={measureRef}
        style={{ visibility: "hidden", position: "absolute", whiteSpace: "pre" }}></span>
      <Typography variant="mobile-body-s-heavy" color="text.primary">
        {unit}
      </Typography>
    </Row>
  );
};

export { TransparentInputWithUnit, TransparentInput };
